import type { EReportChart, IRMetricKey } from '~/presentation/reports/common/type';
import type { OrderByFields } from '~/presentation/reports/ui/ReportTable/types';
import type { ReactNode } from 'react';

import { createContext, useContext, useMemo } from 'react';
import { useGetValues } from '../hooks';

export interface ReportControlProviderProps {
  children: ReactNode;
}

export interface IReportControlContextType {
  dimensions: string[];
  metrics: string[];
  orderBy?: OrderByFields;
  filters: Record<string, any>;
  onChangeOrderBy: (field: string) => void;
  timeDimension?: string;
  metricKey: IRMetricKey;
  chartType: EReportChart;
  dimensionLookup: Set<string>;
  hasCampaign: boolean;
}

export const ReportControlContext = createContext<IReportControlContextType | undefined>(undefined);

export const ReportControlProvider: React.FC<ReportControlProviderProps> = ({ children }) => {
  const values = useGetValues();

  const contextValue = useMemo(
    () => ({
      ...values,
    }),
    [values],
  );
  return (
    <ReportControlContext.Provider value={contextValue}>{children}</ReportControlContext.Provider>
  );
};

export const useReportControlContext = () => {
  const context = useContext(ReportControlContext);
  if (!context) {
    throw new Error('useReportControlContext must be used within a ReportControlProvider');
  }
  return context;
};
